
import {useEffect, useState} from "react";
import { apiRequest } from "../../network/apiClient";
import {API_ENDPOINTS} from "../../api/apiEndpoints";

export const useAccDetAssociatedInfo = (leadID) => {
    const [insuranceData, setInsuranceData] = useState([]);
    const [financingData, setFinancingData] = useState([]);
    const [otherOppData, setOtherOppData] = useState([]);

    const fetchData = async () =>{
        try{
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_ACCOUNTS.ASSOCIATED_INFO}?lead_id=${leadID}`, 'GET')
            setInsuranceData(result.insurance);
            setFinancingData(result.financing);
            setOtherOppData(result.other_opp);
        }catch (error){
            console.error("Error fetching data:", error);
        }
    };
    useEffect(() =>{
        fetchData();
    }, [leadID]);
    return {insuranceData, financingData, otherOppData, refetch: fetchData};
}
